import WowPrice from "@/client/components/wow_price/WowPrice";
import "./itemPage.css";

type CollectedValues = { min: number; max: number; count: number; totalSum: number };

function updateCollectedIfValid(coll: CollectedValues, value: number): void {
    coll.count++;
    coll.totalSum += value;
    if (coll.min > value) coll.min = value;
    if (coll.max < value) coll.max = value;
}

function makeWowPricesIfData(coll: CollectedValues): { min: JSX.Element; max: JSX.Element; avg: JSX.Element } {
    if (coll.count == 0) {
        const noDataPh = <>No Data</>;
        return { min: noDataPh, max: noDataPh, avg: noDataPh };
    }
    return {
        min: <WowPrice short={true} value={coll.min}></WowPrice>,
        max: <WowPrice short={true} value={coll.max}></WowPrice>,
        avg: <WowPrice short={true} value={coll.totalSum / coll.count}></WowPrice>,
    };
}

const ItemShortHistory = ({ valueName, data }: { valueName?: string; data: ApiAuctionItemData[] }): JSX.Element => {
    if (!data[0]) return <>No Data</>;

    const day = 24 * 3600 * 1000;
    const week = 7 * day;
    const month = 4 * week;
    const now = Date.now();
    const dayAgo = now - day;
    const weekAgo = now - week;
    const monthAgo = now - month;

    const collected = {
        day: { min: Number.MAX_VALUE, max: 0, count: 0, totalSum: 0 },
        week: { min: Number.MAX_VALUE, max: 0, count: 0, totalSum: 0 },
        month: { min: Number.MAX_VALUE, max: 0, count: 0, totalSum: 0 },
    };

    for (const entry of data) {
        if (entry.timestamp < monthAgo) continue;
        updateCollectedIfValid(collected.month, entry.minBuyout);
        if (entry.timestamp > weekAgo) updateCollectedIfValid(collected.week, entry.minBuyout);
        if (entry.timestamp > dayAgo) updateCollectedIfValid(collected.day, entry.minBuyout);
    }

    const dispData = {
        day: makeWowPricesIfData(collected.day),
        week: makeWowPricesIfData(collected.week),
        month: makeWowPricesIfData(collected.month),
    };

    return (
        <table className="itemShortHistoryTable">
            <tbody>
                <tr>
                    <th>{valueName}</th>
                    <th>Last 24h</th>
                    <th>Last 7d</th>
                    <th>Last 30d</th>
                </tr>
                <tr>
                    <th>Max.</th>
                    <td>{dispData.day.max}</td>
                    <td>{dispData.week.max}</td>
                    <td>{dispData.month.max}</td>
                </tr>
                <tr>
                    <th>Avg.</th>
                    <td>{dispData.day.avg}</td>
                    <td>{dispData.week.avg}</td>
                    <td>{dispData.month.avg}</td>
                </tr>
                <tr>
                    <th>Min.</th>
                    <td>{dispData.day.min}</td>
                    <td>{dispData.week.min}</td>
                    <td>{dispData.month.min}</td>
                </tr>
            </tbody>
        </table>
    );
};

export default ItemShortHistory;
